import React from 'react';

import AdditionControl from '../../controls/home/Addition';

const AdditionSection = ({
  selectedItemList,
  type,
  style,
  disabledFavorite,
  isDisabled,
  disabledFilterSearch,
  searchCategoriesEffected,
  searchText,
  filterProducts,
  queryConditions,
  isFavoriteView,
  isOverlay,
  gridFilters,
}) => {
  return (
    <AdditionControl
      type={type}
      selectedItemList={selectedItemList}
      disabledFavorite={disabledFavorite}
      isDisabled={isDisabled}
      disabledFilterSearch={disabledFilterSearch}
      searchCategoriesEffected={searchCategoriesEffected}
      searchText={searchText}
      filterProducts={filterProducts}
      queryConditions={queryConditions}
      isFavoriteView={isFavoriteView}
      isOverlay={isOverlay}
      gridFilters={gridFilters}
    />
  );
};

export default AdditionSection;
